/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AccountResponse } from './account-response';
// May contain unused imports in some cases
// @ts-ignore
import { AddressResponse } from './address-response';
// May contain unused imports in some cases
// @ts-ignore
import { AllergenDto } from './allergen-dto';
// May contain unused imports in some cases
// @ts-ignore
import { DislikeDto } from './dislike-dto';
// May contain unused imports in some cases
// @ts-ignore
import { HealthMetricsResponse } from './health-metrics-response';
// May contain unused imports in some cases
// @ts-ignore
import { MedicalConditionDto } from './medical-condition-dto';

/**
 * 
 * @export
 * @interface PartnerUserDetailResponse
 */
export interface PartnerUserDetailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PartnerUserDetailResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {AccountResponse}
     * @memberof PartnerUserDetailResponse
     */
    'account'?: AccountResponse;
    /**
     * 
     * @type {number}
     * @memberof PartnerUserDetailResponse
     */
    'externalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'deliveryNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'dietitianId'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof PartnerUserDetailResponse
     */
    'allergens'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof PartnerUserDetailResponse
     */
    'medicalConditions'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof PartnerUserDetailResponse
     */
    'dislikes'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'affiliateId'?: string;
    /**
     * 
     * @type {Set<AllergenDto>}
     * @memberof PartnerUserDetailResponse
     */
    'userAllergens'?: Set<AllergenDto>;
    /**
     * 
     * @type {Set<MedicalConditionDto>}
     * @memberof PartnerUserDetailResponse
     */
    'userMedicalConditions'?: Set<MedicalConditionDto>;
    /**
     * 
     * @type {Set<DislikeDto>}
     * @memberof PartnerUserDetailResponse
     */
    'userDislikes'?: Set<DislikeDto>;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'deliveryPhoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'channel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'membershipId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'gender'?: PartnerUserDetailResponseGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'birthDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerUserDetailResponse
     */
    'age'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerUserDetailResponse
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerUserDetailResponse
     */
    'weight'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerUserDetailResponse
     */
    'targetWeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'dietGoal'?: PartnerUserDetailResponseDietGoalEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'activityLevel'?: PartnerUserDetailResponseActivityLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserDetailResponse
     */
    'dietType'?: PartnerUserDetailResponseDietTypeEnum;
    /**
     * 
     * @type {HealthMetricsResponse}
     * @memberof PartnerUserDetailResponse
     */
    'healthMetrics'?: HealthMetricsResponse;
    /**
     * 
     * @type {AddressResponse}
     * @memberof PartnerUserDetailResponse
     */
    'address'?: AddressResponse;
}

export const PartnerUserDetailResponseGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE'
} as const;

export type PartnerUserDetailResponseGenderEnum = typeof PartnerUserDetailResponseGenderEnum[keyof typeof PartnerUserDetailResponseGenderEnum];
export const PartnerUserDetailResponseDietGoalEnum = {
    LoseWeight: 'LOSE_WEIGHT',
    Maintenance: 'MAINTENANCE',
    GainWeight: 'GAIN_WEIGHT',
    IncreaseMuscles: 'INCREASE_MUSCLES',
    EatHealthy: 'EAT_HEALTHY'
} as const;

export type PartnerUserDetailResponseDietGoalEnum = typeof PartnerUserDetailResponseDietGoalEnum[keyof typeof PartnerUserDetailResponseDietGoalEnum];
export const PartnerUserDetailResponseActivityLevelEnum = {
    Sedentary: 'SEDENTARY',
    LightlyActive: 'LIGHTLY_ACTIVE',
    ModeratelyActive: 'MODERATELY_ACTIVE',
    VeryActive: 'VERY_ACTIVE',
    ExtremelyActive: 'EXTREMELY_ACTIVE'
} as const;

export type PartnerUserDetailResponseActivityLevelEnum = typeof PartnerUserDetailResponseActivityLevelEnum[keyof typeof PartnerUserDetailResponseActivityLevelEnum];
export const PartnerUserDetailResponseDietTypeEnum = {
    LowCarb: 'LOW_CARB',
    Balanced: 'BALANCED',
    Vegan: 'VEGAN',
    HighProtein: 'HIGH_PROTEIN',
    Keto: 'KETO',
    GlutenFree: 'GLUTEN_FREE'
} as const;

export type PartnerUserDetailResponseDietTypeEnum = typeof PartnerUserDetailResponseDietTypeEnum[keyof typeof PartnerUserDetailResponseDietTypeEnum];


